import React from 'react';
import { Link } from 'react-router-dom';

/**
 * ServiceDetailHeroV2 — hero on /v2/services/:slug.
 * One primary audit CTA lives here; a second (closing) CTA lives at the
 * bottom of the page. No third CTA.
 */
const ServiceDetailHeroV2 = ({ service, lang = 'en', h1Ref }) => {
  if (!service) return null;
  const backLabel = lang === 'es' ? 'Todos los servicios' : 'All services';
  const auditLabel = service.cta_label ||
    (lang === 'es' ? 'Comenzar con una Auditoría de Sistemas de Negocio' : 'Start with a Business Systems Audit');
  return (
    <section className="iv2-service-detail-hero" data-testid="iv2-service-detail-hero">
      <div className="iv2-container">
        <p className="iv2-service-detail-crumbs">
          <Link to={`/v2/services?lang=${lang}`} data-testid="iv2-service-detail-back">
            ← {backLabel}
          </Link>
        </p>
        {service.kicker && (
          <p className="iv2-service-detail-kicker" data-testid="iv2-service-detail-kicker">
            {service.kicker}
          </p>
        )}
        <h1
          ref={h1Ref}
          tabIndex={-1}
          className="iv2-service-detail-title"
          data-testid="iv2-service-detail-title"
        >
          {service.title}
        </h1>
        <p className="iv2-service-detail-short">{service.short_description}</p>
        <Link
          to={`/v2/audit?lang=${lang}`}
          className="iv2-btn iv2-btn-primary iv2-service-detail-cta"
          data-testid="iv2-service-detail-cta"
        >
          {auditLabel}
        </Link>
      </div>
    </section>
  );
};

export default ServiceDetailHeroV2;
